<td-wb-loading-indicator-panel>
  <td-wb-loading-indicator position="top" [displayDelay]="0" />
</td-wb-loading-indicator-panel>
